export const SHOW_DETAIL_TYPE = {
  HOME: 0,
  BENEFICIARY_ADD: 1,
  BENEFICIARY_EDIT: 2,
  TRUSTED_ANGEL_EDIT: 3
};
